import React from 'react'
import injectSheet from 'react-jss'
import Titre1 from './font/Titre1'
import { Col, Collapse, Row } from 'react-bootstrap'
import Prix from './Prix'
import routes from '../routing/routes'
import { Link } from 'react-router-dom'
import responsiveComponent from '../hoc/responsiveComponent'

const styles = theme => ({
  wrapper: {
    backgroundColor: 'white'
  },
  image: {
    width: '100%',
    paddingTop: '90%',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    position: 'relative'
  },
  name: {
    textTransform: 'uppercase',
    '& a': {
      color: theme.titre1
    },
    '& a:hover': {
      color: theme.titre1
    }
  },
  nameAF: {
    textTransform: 'uppercase',
    marginTop: 20,
    '& a': {
      color: theme.titre1
    },
    '& a:hover': {
      color: theme.titre1
    }
  },
  description: {
    textAlign: 'left'
  },
  prix: {
    marginBottom: '0px'
  },
  hr: {
    borderColor: theme.produit.hrColor
  },
  hrAF: {
    borderColor: theme.produit.hrColor,
    marginTop: 0
  },
  plusOffres: {
    fontWeight: theme.regular,
    fontSize: theme.taillePetitTexte,
    color: theme.lien,
    margin: 0,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  compensation: {
    margin: '15px 0px'
  },
  plusDetails: {
    position: 'relative',
    '& a': {
      color: theme.lien
    }
  },
  deleteProduct: {
    position: 'absolute',
    right: 0,
    color: 'red',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  },
  modifyProduct: {
    position: 'absolute',
    left: 0,
    color: theme.lien,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  }
})

class Produit extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isMoreOffer: false }
  }

  clickMoreOffer = () => {
    this.setState(prevState => ({
      isMoreOffer: !prevState.isMoreOffer
    }))
  }

  render() {
    const {
      photosProduct,
      name,
      saleMode,
      classes,
      writeAccess,
      openModalSuppression,
      isMobile,
      position,
      ...props
    } = this.props

    const imagePath =
      photosProduct.length > 0
        ? photosProduct[0].cloudPath
        : '/img/no_photo.jpg'

    return (
      <div className={classes.wrapper}>
        <Row>
          <Col xs={6} sm={12}>
            <Link
              to={routes.ficheProduit.replace(':idProduct(\\d+)', props.id)}
            >
              <div
                className={classes.image}
                style={{ backgroundImage: `url(${imagePath})` }}
                role='img'
                aria-label={name}
              />
            </Link>
          </Col>

          <Col xs={6} sm={12} className={classes.description}>
            <Titre1
              component='p'
              className={isMobile ? classes.name : classes.nameAF}
            >
              <Link
                to={routes.ficheProduit.replace(':idProduct(\\d+)', props.id)}
              >
                <span>{name}</span>
              </Link>
            </Titre1>

            {saleMode &&
              (saleMode.offers ? (
                // PackedSale
                <div>
                  <Prix
                    className={`${classes.prix} ${
                      saleMode.offers.length < 2 ? classes.compensation : ''
                    }`}
                    price={saleMode.offers[0].price}
                    unit={saleMode.offers[0].unit}
                    quantity={saleMode.offers[0].quantity}
                    pieces={saleMode.offers[0].pieces}
                    idProduct={props.id}
                    noSeo
                  />

                  {/* Si il y a plus d'offres */}
                  {saleMode.offers.length > 1 ? (
                    <div>
                      <span
                        className={classes.plusOffres}
                        onClick={this.clickMoreOffer}
                      >
                        + offres
                      </span>
                      <Collapse in={this.state.isMoreOffer}>
                        <div>
                          {saleMode.offers
                            .filter((offer, i) => i > 0)
                            .map((offer, i) => (
                              <Prix
                                key={i}
                                className={classes.prix}
                                price={offer.price}
                                quantity={offer.quantity}
                                pieces={offer.pieces}
                                unit={offer.unit}
                                idProduct={props.id}
                                noSeo
                              />
                            ))}
                        </div>
                      </Collapse>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              ) : (
                // BulkSale
                <div>
                  <Prix
                    className={`${classes.prix} ${classes.compensation}`}
                    bulksale
                    price={saleMode.price}
                    unit={saleMode.unit}
                    idProduct={props.id}
                    noSeo
                  />
                </div>
              ))}
            <div className={classes.plusDetails}>
              {writeAccess && (
                <>
                  <Link
                    to={{
                      pathname: routes.addProduct,
                      state: { product: props.product }
                    }}
                    className={classes.modifyProduct}
                  >
                    Modifier
                  </Link>
                  <span
                    className={classes.deleteProduct}
                    onClick={() => openModalSuppression(props.id)}
                  >
                    Supprimer
                  </span>
                </>
              )}
            </div>
          </Col>
        </Row>

        <div {...props}>
          <hr className={isMobile ? classes.hr : classes.hrAF} />
        </div>
      </div>
    )
  }
}

export default responsiveComponent(injectSheet(styles)(Produit))
